import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export type UserStatusesName = keyof typeof userStatusesEnum
export const userStatusesEnum = {
  ACTIVE: { label: "Actif", color: "success.main" },
  DEACTIVATED: { label: "Désactivé", color: "common.red" },
} as const satisfies ReferentialEnum<{ color: string }>

export const userStatusesReferential =
  referentialEnumToReferentialCodeList(userStatusesEnum)
